!function () {
    "use strict";
    angular.module("ngMaterialCollapsible", ["ngMaterial"])
}();

!function () {
    "use strict";
    function e() {
        return {
            restrict: "E",
            link: function (e, t) {
                t.attr("layout", "column"), t.addClass("layout-column")
            }
        }
    }
    function t() {
        return {
            restrict: "E",
            scope: {
                isOpen: "=?mdOpen"
            },
            link: function (e, t) {
                e.isOpen && t.addClass("active")
            }
        }
    }
    function n() {
        return {
            restrict: "E", transclude: !0,
            template: '<div layout="column" ng-transclude></div>'
        }
    }
    function l() {
        return {
            restrict: "E",
            transclude: !0,
            template: '<div layout="row" class="md-collapsible-tools" ng-transclude></div>',
            link: function (e, t) {
                function n(e) {
                    if (l(e)) {
                        var n = angular.element(t[0].parentElement);
                        if (n.hasClass(i)) return void n.removeClass(i);
                        var r = angular.element(n[0].parentElement);
                        r.hasClass("multiple-open") || a(r), n.addClass(i)
                    }
                }
                function l(e) {
                    var t = ["md-icon", "md-button", "button", "a", "md-checkbox"];
                    return t.indexOf(e.target.localName) < 0 && !e.target.hasAttribute("md-ink-ripple-checkbox")
                }
                function a(e) {
                    angular.forEach(e[0].children, function (e) {
                        e = angular.element(e), e.hasClass(i) && e.removeClass(i)
                    })
                }
                var i = "active"; t.on("click", n)
            }
        }
    }
    angular.module("ngMaterialCollapsible").directive("mdCollapsible", e).directive("mdCollapsibleItem", t).directive("mdCollapsibleHeader", l).directive("mdCollapsibleBody", n)
}();


// WEBPACK FOOTER //
// ./src/libs/collapsibleDirective.min.js